module.exports = __webpack_public_path__ + "img/avatar0.674f611d.png";